import React, { useCallback, useEffect, useState } from "react";
import "./style.scss";
import Button from "../../../vapor/button";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../reducers/store";
import Spinner from "../../../vapor/spinner";
import { FormattedMessage, useIntl } from "react-intl";
import { Close } from "@mui/icons-material";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    FormControl,
    FormHelperText,
    Grid,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Step,
    StepLabel,
    Stepper,
} from "@vapor/react-material";
import { ClosingDates } from "../../../../reducers/search";
import AttoTrasferimentiModal from "./attoTrasferimentiModal";
import moment from "moment";
import { buyCompanyProduct } from "../../../../actions/products";
import { getOrderJson } from "../../../../actions/orders";
import { getUserPackage } from "../../../../actions/userPackage";

interface BuyProductModalProps {
    product: any;
    onConfirm: () => void;
    onConfirmAtto: (val?: any) => void;
    onCancel: () => void;
    balanceType?: any;
    setBalanceType?: (val: any) => void;
    balanceYear?: any;
    setBalanceYear?: (val: any) => void;
    attoParams?: any;
    setAttoParams?: (val: any) => void;
    companySelected?: any;
}

const BuyProductModal = (props: BuyProductModalProps) => {
    const products = useSelector((state: RootState) => state.products);
    const closing_dates = useSelector(
        (state: RootState) => state?.search?.products?.closing_dates,
    );

    const dispatch: any = useDispatch();

    const [activeStep, setActiveStep] = useState(0);
    const [years, setYears] = useState([] as number[]);
    const [startDate, setStartDate] = useState<string>(
        moment().subtract(6, "months").format("YYYY-MM-DD"),
    );
    const [endDate, setEndDate] = useState<string>(
        moment().format("YYYY-MM-DD"),
    );
    const [listaAtti, setListaAtti] = useState<Array<any>>([]);
    const [kDoc, setKDoc] = useState<any>("");
    const [isGettingJson, setIsGettingJson] = useState<boolean>(false);

    useEffect(() => {
        setStartDate(
            moment(endDate).subtract(6, "months").format("YYYY-MM-DD"),
        );
    }, [endDate]);

    const handleBalanceType = useCallback(
        (value: any) => {
            if (props.setBalanceYear) {
                props.setBalanceYear(null);
            }
            if (props?.setBalanceType) {
                props?.setBalanceType(value);
                const typeToBool = value === "consolidated" ? true : false;
                if (closing_dates) {
                    setYears(
                        closing_dates
                            ?.filter(
                                (closing_date: ClosingDates) =>
                                    closing_date?.is_consolidated ===
                                    typeToBool,
                            )
                            ?.map(
                                (closing_date: ClosingDates) =>
                                    closing_date?.year,
                            )
                            ?.sort((a: number, b: number) => b - a) as any,
                    );
                }
            }
        },
        [props, closing_dates],
    );

    const onBuyList = () => {
        dispatch(
            buyCompanyProduct(
                props.companySelected,
                "LISTA_ATTI_TRASFERIMENTI_AZIENDA",
                null,
                null,
                startDate,
                endDate,
            ),
        ).then((res: any) => {
            setIsGettingJson(true);
            dispatch(getOrderJson(res?.order_id))
                .then((res2: any) => {
                    setIsGettingJson(false);
                    dispatch(getUserPackage());
                    setListaAtti(res2?.result);
                    setActiveStep(1);
                })
                .catch((err: any) => {
                    setIsGettingJson(false);
                    throw new Error(`${err.code}: Error reading data`);
                });
        });
    };

    const BilancioModal = (props: BuyProductModalProps) => {
        const intl = useIntl();
        return (
            <div className="bis-modals-buyProduct-bilancio-root">
                <div className="bis-modals-buyProduct-bilancio-stepper">
                    <Stepper activeStep={activeStep} alternativeLabel>
                        <Step>
                            <StepLabel>
                                <FormattedMessage id="modals.buy.balance.step1" />
                            </StepLabel>
                        </Step>
                        <Step>
                            <StepLabel>
                                <FormattedMessage id="modals.buy.balance.step2" />
                            </StepLabel>
                        </Step>
                    </Stepper>
                </div>
                {activeStep === 0 && (
                    <div className="bis-modals-buyProduct-bilancio-content">
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <FormControl fullWidth>
                                    <InputLabel id="bis-modals-buyProduct-bilancio-type-label">
                                        <FormattedMessage id="modals.buy.balance.type" />
                                    </InputLabel>
                                    <Select
                                        id="bis-modals-buyProduct-bilancio-type"
                                        label={
                                            <FormattedMessage id="modals.buy.balance.type" />
                                        }
                                        labelId="bis-modals-buyProduct-bilancio-type-label"
                                        onChange={(e) => {
                                            handleBalanceType(
                                                e.target.value as string,
                                            );
                                        }}
                                        placeholder={intl.formatMessage({
                                            id: "modals.buy.balance.placeholder",
                                        })}
                                        value={props.balanceType}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 312,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem disabled value="none">
                                            <FormattedMessage id="modals.buy.balance.selectOption" />
                                        </MenuItem>
                                        {closing_dates?.some(
                                            (closing_date: ClosingDates) =>
                                                closing_date?.is_consolidated ===
                                                true,
                                        ) && (
                                            <MenuItem value="consolidated">
                                                <FormattedMessage id="modals.buy.balance.consolidated" />
                                            </MenuItem>
                                        )}
                                        {closing_dates?.some(
                                            (closing_date: ClosingDates) =>
                                                closing_date?.is_consolidated ===
                                                false,
                                        ) && (
                                            <MenuItem value="ordinary">
                                                <FormattedMessage id="modals.buy.balance.ordinary" />
                                            </MenuItem>
                                        )}
                                    </Select>
                                    <FormHelperText></FormHelperText>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12}>
                                <FormControl
                                    disabled={
                                        !props.balanceType ||
                                        props.balanceType === "none" ||
                                        years.length === 0
                                    }
                                    fullWidth
                                >
                                    <InputLabel id="bis-modals-buyProduct-bilancio-year-label">
                                        <FormattedMessage id="modals.buy.balance.year" />
                                    </InputLabel>
                                    <Select
                                        disabled={!props.balanceType}
                                        id="bis-modals-buyProduct-bilancio-year"
                                        label={
                                            <FormattedMessage id="modals.buy.balance.year" />
                                        }
                                        labelId="bis-modals-buyProduct-bilancio-year-label"
                                        onChange={(e) => {
                                            props.setBalanceYear?.(
                                                e.target.value,
                                            );
                                        }}
                                        value={props.balanceYear}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 242,
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem disabled value="none">
                                            <FormattedMessage id="modals.buy.balance.selectOption" />
                                        </MenuItem>
                                        {years?.map((y) => {
                                            return (
                                                <MenuItem value={y.toString()}>
                                                    {y}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                    <FormHelperText></FormHelperText>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </div>
                )}
                {activeStep === 1 && (
                    <div className="bis-modals-buyProduct-content">
                        <div className="bis-modals-buyProduct-content-text">
                            <FormattedMessage id="modals.buy.buying" />:
                        </div>
                        <div className="bis-modals-buyProduct-content-product">
                            {
                                products.data.find(
                                    (product) =>
                                        product.product ===
                                        props.product.product,
                                )?.name
                            }{" "}
                            -{" "}
                            <FormattedMessage
                                id={`modals.buy.balance.${props.balanceType}`}
                            />{" "}
                            ({<FormattedMessage id="general.year" />}{" "}
                            {props.balanceYear})
                        </div>
                        <div className="bis-modals-buyProduct-content-text">
                            <FormattedMessage id="modals.buy.description1" />{" "}
                            <strong>{props.product.price}</strong>{" "}
                            <FormattedMessage id="modals.buy.description2" />
                        </div>
                    </div>
                )}
            </div>
        );
    };

    return (
        <Dialog
            open={props.product !== null}
            onClose={(event, reason) => {
                if (reason && reason === "backdropClick") return;
                props.onCancel();
            }}
        >
            <DialogTitle>
                <FormattedMessage id="modals.buy.title" />
                {!products.isBuyingProduct &&
                    !isGettingJson &&
                    listaAtti?.length === 0 && (
                        <IconButton
                            color="primary"
                            onClick={() => props.onCancel()}
                        >
                            <Close />
                        </IconButton>
                    )}
            </DialogTitle>
            <Divider variant="fullWidth" />
            <DialogContent>
                {" "}
                {products.isBuyingProduct &&
                (props.product.product !== "ATTO_TRASFERIMENTI_AZIENDA" ||
                    (props.product.product === "ATTO_TRASFERIMENTI_AZIENDA" &&
                        activeStep === 1)) ? (
                    <div className="bis-modals-buyProduct-content-spinner">
                        <Spinner
                            message={
                                <FormattedMessage id="modals.buy.spinner" />
                            }
                        />
                    </div>
                ) : (products.isBuyingProduct || isGettingJson) &&
                  props.product.product === "ATTO_TRASFERIMENTI_AZIENDA" &&
                  activeStep === 0 ? (
                    <div className="bis-modals-buyProduct-content-spinner">
                        <Spinner
                            message={
                                <FormattedMessage id="modals.buy.spinnerList" />
                            }
                        />
                    </div>
                ) : ["BILANCIO_XBRL", "BILANCIO_COMPLETO"].indexOf(
                      props.product.product,
                  ) > -1 ? (
                    <BilancioModal
                        {...props}
                        balanceType={props.balanceType}
                        balanceYear={props.balanceYear}
                        setBalanceType={(val: any) =>
                            props.setBalanceType?.(val)
                        }
                        setBalanceYear={(val: any) =>
                            props.setBalanceYear?.(val)
                        }
                    />
                ) : ["ATTO_TRASFERIMENTI_AZIENDA"].indexOf(
                      props.product.product,
                  ) > -1 ? (
                    <AttoTrasferimentiModal
                        {...props}
                        activeStep={activeStep}
                        setActiveStep={setActiveStep}
                        startDate={startDate}
                        endDate={endDate}
                        setEndDate={setEndDate}
                        listaAtti={listaAtti}
                        kDoc={kDoc}
                        setKDoc={setKDoc}
                    />
                ) : (
                    <div className="bis-modals-buyProduct-content">
                        <div className="bis-modals-buyProduct-content-text">
                            <FormattedMessage id="modals.buy.buying" />:
                        </div>
                        <div className="bis-modals-buyProduct-content-product">
                            {
                                products.data.find(
                                    (product) =>
                                        product.product ===
                                        props.product.product,
                                )?.name
                            }
                        </div>
                        <div className="bis-modals-buyProduct-content-text">
                            <FormattedMessage id="modals.buy.description1" />{" "}
                            <strong>{props.product.price}</strong>{" "}
                            <FormattedMessage id="modals.buy.description2" />
                        </div>
                    </div>
                )}
            </DialogContent>
            {!products.isBuyingProduct &&
                ["ATTO_TRASFERIMENTI_AZIENDA"].indexOf(
                    props.product.product,
                ) === -1 && (
                    <DialogActions>
                        <div className="bis-modals-buyProduct-footer">
                            {((["BILANCIO_XBRL", "BILANCIO_COMPLETO"].indexOf(
                                props.product.product,
                            ) > -1 &&
                                activeStep === 0) ||
                                ["BILANCIO_XBRL", "BILANCIO_COMPLETO"].indexOf(
                                    props.product.product,
                                ) === -1) && (
                                <Button
                                    onClick={() => props.onCancel()}
                                    kind="secondary"
                                    size="medium"
                                >
                                    <FormattedMessage id="actions.cancel" />
                                </Button>
                            )}
                            {["BILANCIO_XBRL", "BILANCIO_COMPLETO"].indexOf(
                                props.product.product,
                            ) > -1 &&
                                activeStep === 1 && (
                                    <Button
                                        onClick={() => setActiveStep(0)}
                                        kind="secondary"
                                        size="medium"
                                    >
                                        <FormattedMessage id="actions.prev" />
                                    </Button>
                                )}
                            {["BILANCIO_XBRL", "BILANCIO_COMPLETO"].indexOf(
                                props.product.product,
                            ) > -1 &&
                                activeStep === 0 && (
                                    <Button
                                        disabled={
                                            !props.balanceType ||
                                            !props.balanceYear ||
                                            props.balanceType === "none" ||
                                            props.balanceYear === "none"
                                        }
                                        onClick={() => setActiveStep(1)}
                                        size="medium"
                                    >
                                        <FormattedMessage id="actions.next" />
                                    </Button>
                                )}
                            {((["BILANCIO_XBRL", "BILANCIO_COMPLETO"].indexOf(
                                props.product.product,
                            ) > -1 &&
                                activeStep === 1) ||
                                ["BILANCIO_XBRL", "BILANCIO_COMPLETO"].indexOf(
                                    props.product.product,
                                ) === -1) && (
                                <Button
                                    onClick={() => props.onConfirm()}
                                    size="medium"
                                >
                                    <FormattedMessage id="actions.buy" />
                                </Button>
                            )}
                        </div>
                    </DialogActions>
                )}
            {!products.isBuyingProduct &&
                !isGettingJson &&
                ["ATTO_TRASFERIMENTI_AZIENDA"].indexOf(props.product.product) >
                    -1 && (
                    <DialogActions>
                        <div className="bis-modals-buyProduct-footer">
                            {activeStep === 0 && (
                                <Button
                                    onClick={() => props.onCancel()}
                                    kind="secondary"
                                    size="medium"
                                >
                                    <FormattedMessage id="actions.cancel" />
                                </Button>
                            )}
                            {activeStep === 0 && (
                                <Button
                                    disabled={!moment(endDate).isValid()}
                                    onClick={() => onBuyList()}
                                    size="medium"
                                >
                                    <FormattedMessage id="actions.next" />
                                </Button>
                            )}
                            {activeStep === 1 && (
                                <Button
                                    disabled={!kDoc}
                                    onClick={() => props.onConfirmAtto(kDoc)}
                                    size="medium"
                                >
                                    <FormattedMessage id="actions.buy" />
                                </Button>
                            )}
                        </div>
                    </DialogActions>
                )}
        </Dialog>
    );
};

export default BuyProductModal;
